import React from 'react';
import {createRoot} from 'react-dom/client';
import './css/index.css';
import App from './js/application/App';
import {polyfillLocales} from "./intl-polyfills";
import { AppContextProvider } from './js/context/AppContext';


const container = document.getElementById('root');
if (!container) {
    throw new Error('Failed to find the root element');
}

const root = createRoot(container);

polyfillLocales().finally(() =>
    root.render(
        <AppContextProvider>
            <App />
        </AppContextProvider>,
    ),
);

